import * as s from "../StatsStyled";
import SelectComponent from "components/atoms/select/SelectComponent";
import { intervalOneOptions, intervalOptions } from "utils/options";
import { statsInterval } from "api/interfaces/widgetInterface.interface";
import { VscGraphLine } from "react-icons/vsc";
import { IoStatsChart } from "react-icons/io5";
import { FiMoreVertical } from "react-icons/fi";
import { Popover } from "antd";
import { useStatsWidget } from "./GridChartItem";
import { WithTooltip } from "components/blocks/WithTooltip";
import { HiOutlineTrash } from "react-icons/hi";

export interface GraphHeaderProps {
  items: { key: string; label: string }[];
  isShowButton: boolean;
  useInterval?: boolean;
  onChangeInterval?: (interval: statsInterval) => void;
  interval?: statsInterval;
}

const graphTypeOptions = ["line", "stackedBar"];

export default function GraphHeader({
  items,
  isShowButton,
  useInterval = true,
  onChangeInterval,
  interval,
}: GraphHeaderProps) {
  const { onChangeGraphType, title, graphType, onRemoveChart, chartId } =
    useStatsWidget();
  const isLine = (type: string) => type === "line";
  const columnCount =
    1 +
    (isShowButton && items.length > 1 ? 1 : 0) +
    (useInterval && onChangeInterval ? 1 : 0);
  return (
    <s.Chart.Header columnCount={columnCount}>
      <s.Chart.HeaderTitle>
        {title}
        {/* <WidgetSettings /> */}
      </s.Chart.HeaderTitle>

      <s.Chart.HeaderInterval>
        {onChangeInterval && (
          <SelectComponent
            options={useInterval ? intervalOptions : intervalOneOptions}
            onChange={(value) => onChangeInterval?.(value as statsInterval)}
            value={(useInterval ? intervalOptions : intervalOneOptions).find(
              (option) => option.value === (interval ?? "DAILY").toUpperCase()
            )}
            data-testid={`dashboard-stats-graph-selects-change-${(
              title ?? ""
            ).replaceAll(" ", "-")}-${interval}`}
            style={!useInterval ? { width: 120 } : undefined}
          />
        )}
        {graphType !== "donut" &&
          graphTypeOptions.map((type, index) => (
            <s.Chart.GraphTypeButton
              key={type}
              onClick={() => onChangeGraphType(type)}
              $active={graphType === type}
              right={index === 1}
              data-testid={`dashboard-stats-graph-type-button-${(
                title ?? ""
              ).replaceAll(" ", "-")}-${type}`}
            >
              {isLine(type) ? (
                <VscGraphLine size={14} />
              ) : (
                <IoStatsChart size={14} />
              )}
              {isLine(type) ? "Line" : "Bar"}
            </s.Chart.GraphTypeButton>
          ))}
        <s.Chart.RemoveButton
          type="button"
          onClick={() => onRemoveChart(chartId)}
          data-testid={`dashboard-stats-graph-remove-button-${(
            title ?? ""
          ).replaceAll(" ", "-")}`}
        >
          <WithTooltip tooltip="Remove Widget">
            <HiOutlineTrash size={14} />
          </WithTooltip>
        </s.Chart.RemoveButton>
      </s.Chart.HeaderInterval>
    </s.Chart.Header>
  );
}

export function WidgetSettings() {
  const { chartId, onReplaceChart, onRemoveChart, hiddenCharts } =
    useStatsWidget();
  return (
    <Popover
      arrow={false}
      trigger="click"
      placement="bottomRight"
      content={
        <s.Chart.WidgetSettingsContent>
          {hiddenCharts.map((chart) => (
            <li key={chart.i}>
              <button
                type="button"
                onClick={() => onReplaceChart(chartId, chart.i)}
              >
                {chart.title}
              </button>
            </li>
          ))}
          <li className="remove">
            <button type="button" onClick={() => onRemoveChart(chartId)}>
              Remove Widget
            </button>
          </li>
        </s.Chart.WidgetSettingsContent>
      }
    >
      <s.Chart.MoreButton data-testid={`more-button-${chartId}`}>
        <FiMoreVertical size={14} />
      </s.Chart.MoreButton>
    </Popover>
  );
}
